<mat-tab-group #CSTTabGroup
  [animationDuration]='animationDuration' 
  [backgroundColor]='backgroundColor' 
  [color]='color'
  [disableRipple]='disableRipple' 
  [dynamicHeight]='dynamicHeight'
  [headerPosition]='headerPosition' 
  [selectedIndex]='selectedIndex' 
  (animationDone)='animationDone.emit($event)'
  (focusChange)='focusChange.emit($event)' 
  (selectedIndexChange)='selectedIndexChange.emit($event)'
  (selectedTabChange)='handleSelectedTabChange($event)'
  [ngClass]="{'hideTabs': !showTabs, 'childTabs': isChildTabs}">
  <ng-content #CSTTabGroupOutlet></ng-content>
</mat-tab-group>
